module.exports = __webpack_public_path__ + "static/media/Lus-min.207886e5.PNG";